app.factory(
    'ApiService', ['$http', '$q', 'Configuration', ApiService]
);
appexport.factory(
    'ApiService', ['$http', '$q', 'Configuration', ApiService]
);
function ApiService($http, $q, Configuration) {
    return {
        header : function (headers) {
            var header = {};
            
            if (headers) {
                console.log(headers);
            } else {
                header = {
                    'Content-Type' : 'application/json',
                    //'X-API-TOKEN' : (UserService.getToken())
                }
            }
            return header;
        },
        getsilent: function (url, header) {
            var defer = $q.defer();
            var req = {
                method: 'GET',
                url: Configuration.api.url + url,
                headers: this.header(header),
                ignoreLoadingBar: true
                // data : data
            };

            $http(req).then(
               function (result) {
                   defer.resolve(result);
               }
           ).catch(
               function (error) {
                   if (error.status === 422 || error.status === 401) {
                       defer.resolve(error.data);
                   } else {
                       var Error = "Erreur Api, Veuillez contacter votre administrateur";
                       defer.reject(Error);
                   }
               }
           );
            return defer.promise;
        },
        get : function (url,header) {
            var defer = $q.defer();
            var req = {
                method : 'GET',
                url : Configuration.api.url + url,
                headers : this.header(header),
                // data : data
            };
            $http(req).then(
                function (result) {
                    defer.resolve(result);
                }
            ).catch(
                function (error) {
                    if (error.status === 422 || error.status === 401) {
                        defer.resolve(error.data);
                    } else {
                        var Error = "Erreur Api, Veuillez contacter votre administrateur";
                        defer.reject(Error);
                    }
                }
            );
            return defer.promise;
        },
        post : function (url, data, resptype,header) {
            var defer = $q.defer();
            var req = {
                method : 'POST',
                url : Configuration.api.url + url,
                headers: this.header(header),
                responseType: resptype,
                data : data
            };
            $http(req).then(
                function (result) {
                    defer.resolve(result);
                }
            ).catch(
                function (error) {
                    if (error.status === 422 || error.status === 401) {
                        defer.resolve(error.data);
                    } else {
                        var Error = "Erreur Api, Veuillez contacter votre administrateur";
                        defer.reject(Error);
                    }
                }
            );
            return defer.promise;
        },
      
        postMultipart : function (url, data) {
            var defer = $q.defer();
            var req = {
                method : 'POST',
                url : Configuration.api.url + url,
                headers : {
                    'Content-Type' : undefined,
                    //'X-API-TOKEN' : (UserService.getToken())
                },
                transformRequest : function (data) {
                    return data;
                },
                data : data
            };
            $http(req).then(
                function (result) {
                    defer.resolve(result);
                }
            ).catch(
                function () {
                    var Error = "Erreur Api, Veuillez contacter votre administrateur";
                    defer.reject(Error);
                }
            );
            return defer.promise;
        }
    };
}